import React, { Component } from 'react'
import moment from 'moment'

class PendingSuspendedDetalhes extends Component {
    constructor(props) {
        super(props)
        this.state = {
            checkboxPedido: '',
            //--------------
            data:'',
            textboxArea: '',
            NumeroSeloFinal: 0,
            NumeroSeloInicial: 0,
            seriesCheck:''
        }
    }
    radioPedidos = (e) => {
        let data = {...this.state.data}
        switch (e.target.value) {
            case "recusar":
                data["IDEstado"] = 7
                data["IDTipoOperacao"] = 7
                break;
            
            case "suspender":
                data["IDEstado"] = 12
                data["IDTipoOperacao"] = 12
                break;
            
            case "aprovar":
                data["IDEstado"] = 6
                data["IDTipoOperacao"] = 6
                break;
        
            default:
                break;
        }
        data["Observacoes"] = ''
        this.setState({
            data,
            [e.target.name] : e.target.value,
            textboxArea: ''
        },() => {
            this.props.setData(this.state.data)
        })
    }

    textFill = (e) => {
        e.persist()

        this.setState({
            textboxArea: e.target.value,
            data : {...this.state.data, Observacoes: e.target.value}
        }, () => {
            this.props.setData(this.state.data) 
        })
    }

    serieCheck = (serie) => {
        this.setState({
            seriesCheck: serie['numeroInicial'],
            data: {...this.state.data, NumeroSeloInicial: serie['numeroInicial'], NumeroSeloFinal: serie['numeroFinal']}
        },() => {
            this.props.setData(this.state.data)
        })
    }
    render() {
        let row = this.props.row
        console.log("777777777777777777777777777",row)
        let commonJSX = (
            <>
                <div className="input-box active-grey">
                    <label className="input-label"><strong>Observações</strong></label>
                    <textarea
                        className="form-control heigh-auto" rows="3"
                        name="Obser"
                        value={this.state.textboxArea}
                        onChange={(e) => this.textFill(e)}>
                    </textarea>
                </div>
                {(this.state.checkboxPedido === "suspender" || this.state.checkboxPedido === "aprovar") ? 
                    (<></>
                    // <p>* Campo de preenchimento opcional</p>
                    )
                    :
                    (<p>* Campo de preenchimento obrigatório</p>)
                }
            </>
        )
        return (
            <>
                <div className="mt-3">
                    <div className="col-md-12">
                        <label><strong>Nº Pedido</strong></label>
                        <p>{row['nº pedido']}</p>
                    </div>

                    <div className="col-md-12 my-2">
                        <label><strong>Data de submissão</strong></label>
                        <p>{moment(row['dataCriado']).format('DD/MM/YY')}</p>
                    </div>

                    <div className="col-md-12 my-2 d-flex">
                        <div className="mr-5">
                            <label><strong>Tipo de pedido</strong></label>
                            <p>{row['Tipo de pedido']}</p>
                        </div>
                        {/*Condition based*/}
                        {
                            (this.props.pedidos === 'pending' || this.props.pedidos === 'stampPending') && 
                            <div className="ml-5">
                                <label><strong>Número de registos</strong></label>
                                <p>{row['codRegistoSelo']}</p>
                            </div>
                        }
                    </div>

                    <div className="col-md-12 my-2">
                        <label><strong>Observações do requisitante</strong></label>
                        <p>{row['observacao']}</p>
                    </div>

                    <div className="col-md-12 my-2">
                        <label><strong>Estado do pedido</strong></label>
                        <p>{row['Estado']}</p>
                    </div>

                </div>
                
                <div className="checkboxes col-md-12">
                <label><strong>Decisão</strong></label><br/>
                    <label>
                        <input 
                        type="radio" 
                        name="checkboxPedido" 
                        className="mr-1" 
                        onChange={(e) => {this.radioPedidos(e)}} 
                        value="recusar"
                        checked={this.state.checkboxPedido === "recusar"}/>
                        Recusar
                    </label><br/>
                    {
                        this.state.checkboxPedido === "recusar" && commonJSX
                    }
                    
                    <label>
                        <input 
                        type="radio" 
                        name="checkboxPedido" 
                        className="mr-1" 
                        onChange={(e) => {this.radioPedidos(e)}} 
                        value="suspender" 
                        checked={this.state.checkboxPedido === "suspender"}/>
                        Suspender
                    </label><br/>
                    {
                        this.state.checkboxPedido === "suspender" && commonJSX
                    }

                    <label>
                        <input 
                        type="radio" 
                        name="checkboxPedido" 
                        className="mr-1"
                        onChange={(e) => {this.radioPedidos(e)}} 
                        value="aprovar" 
                        checked={this.state.checkboxPedido === "aprovar"}/>
                        Aprovar
                    </label>
                    
                    {
                        this.state.checkboxPedido === "aprovar" && 
                    
                        <>
                            <div>
                                <p>Selecionou (n) de /100 solicitados</p>
                                <table className="w-100 text-center">
                                    <thead className="border">
                                        <tr className="d-flex justify-content-around py-2">
                                            <td></td>
                                            
                                            {this.props.pedidos === 'stampPending' ? (
                                                <td className="w-25"><strong>Tipo Selo</strong></td>
                                            ) 
                                            : (
                                                <td className="w-25"><strong>Serie</strong></td>
                                            )}
                                            <td className="w-25"><strong>Nº inicial</strong></td>
                                            <td className="w-25"><strong>Nº final</strong></td>
                                            <td className="w-25"><strong>Nº Selos</strong></td>
                                        </tr>
                                    </thead>
                                    <tbody className="border">
                                    {
                                        this.props.sealsRes.length > 0 ? 
                                        (
                                            this.props.sealsRes.map(serie => (
                                                <tr key={serie['numeroInicial']}  className="d-flex justify-content-around py-2 border">
                                                    <td style={{marginLeft: "10px"}}><input 
                                                            type="checkbox"
                                                            onChange={() => this.serieCheck(serie)}
                                                            checked={this.state.seriesCheck === serie['numeroInicial'] ? true : false}
                                                        /></td>
                                                    <td className="w-25">{row['tipoSelo']}</td>
                                                    <td className="w-25">{serie['numeroInicial']}</td>
                                                    <td className="w-25">{serie['numeroFinal']}</td>
                                                    <td className="w-25">{serie['seloRestante']}</td>
                                                </tr>
                                            ))
                                        ) 
                                        : 
                                        (
                                            <tr>
                                                <td colSpan="5">Sem resultados</td>
                                            </tr>
                                        )
                                        
                                    }
                                    </tbody>
                                </table>
                            </div>
                            {commonJSX}
                        </> 
                    }
                </div>
            </>
            
        )
    }
}

export default PendingSuspendedDetalhes